import { render } from "./DialogInfo.vue?vue&type=template&id=29fb5a65"
import script from "./DialogInfo.vue?vue&type=script&lang=js"
export * from "./DialogInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__